import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useMemo } from "react";
import useIsMobile from "../../../../hooks/device/useIsMobile.js";
import { MobileSearcherWrapper, SearcherContent, SearcherMiddle, SearcherTop, SearcherWrapper } from "./styled.js";
export const Searcher = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { top , TopComponent =SearcherTop , topProps , MiddleComponent =SearcherMiddle , middleProps , children , ...rest } = props;
    const isMobile = useIsMobile();
    const content = useMemo(()=>/*#__PURE__*/ _jsxs(SearcherContent, {
            children: [
                top && /*#__PURE__*/ _jsx(TopComponent, {
                    ...topProps,
                    children: top
                }),
                children && /*#__PURE__*/ _jsx(MiddleComponent, {
                    ...middleProps,
                    children: children
                })
            ]
        }), [
        top,
        TopComponent,
        topProps,
        children,
        MiddleComponent,
        middleProps
    ]);
    if (isMobile) {
        return /*#__PURE__*/ _jsx(MobileSearcherWrapper, {
            ...rest,
            ref: ref,
            children: content
        });
    }
    return /*#__PURE__*/ _jsx(SearcherWrapper, {
        ...rest,
        ref: ref,
        children: content
    });
});
Searcher.displayName = 'Searcher';
export default Searcher;

//# sourceMappingURL=index.js.map